<p-overlayPanel #op>
    <ng-template pTemplate="content" class="notification-overlayPanel">
        <div class="notifications-content">
            <ng-container *ngFor="let notificationItem of notificationItems">
                <ng-container [ngTemplateOutlet]="notificationItemTemplate"
                    [ngTemplateOutletContext]="{notificationData:notificationItem}"></ng-container>
            </ng-container>
        </div>
    </ng-template>
</p-overlayPanel>
<!-- badge-hidden class is used due to bug on primeNg disabled badge -->
<k-button check-cookies-expired outline="true" roundedIcon="true" height="35px" width="35px"
    (click)="op.toggle($event); openNotificationPanel()" pBadge [value]="numberUnreadNotification"
    [ngClass]="{'badge-hidden':numberUnreadNotification==0}">
    <fa-icon [icon]="'bell'"></fa-icon>
</k-button>

<ng-template #notificationItemTemplate let-notification="notificationData">
    <a [href]="notification.redirect_url" target="_blank">
        <div *transloco="let t;" class="flex notification-item">
            <img class="mr-3" [src]="notification.img_url">
            <div class="notification-details">
                <p class="notification-title">
                    {{notification.title}}
                </p>
                <p class="notification-description">
                    {{notification.description}}
                </p>
                <div class="notification-date">
                    {{t(notification.etaAgo.text,{number:notification.etaAgo?.value})}}
                    <!-- {{notification.etaAgo?.value}} {{notification.etaAgo.text}} -->
                </div>
            </div>
        </div>
    </a>
</ng-template>